import script from "./TestChoiceCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TestChoiceCard.vue?vue&type=script&setup=true&lang=js"

import "./TestChoiceCard.vue?vue&type=style&index=0&id=7cef0d9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cef0d9a"]])

export default __exports__